/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { useTranslation } from "react-i18next";

const SavePlanPopup = ({ afterPopupCLose, planId, setPlanId }) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [pricing, setPricing] = useState("");
  const [duration, setDuration] = useState("");
  const [noOfPersonsAllowed, setnoOfPersonsAllowed] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  // KPIs form repeater
  const kpistemplate = { value: "" };
  const [kpis, setKpis] = useState([]);

  const offcanvasBodyRef = useRef(null); // Ref for the scrollable area

  // KPIs form repeater
  const onAddKpi = () => {
    setKpis([...kpis, kpistemplate]);
  };

  // KPIs form repeater
  const changeKpi = (index, data) => {
    const updatedFormValues = kpis.map((kpi, i) =>
      index === i ? { ...kpi, value: data } : kpi
    );
    setKpis(updatedFormValues);
  };

  // KPIs form repeater
  const onDeleteKpi = (index) => {
    const filteredBlock = kpis.filter((_, i) => i !== index);
    setKpis(filteredBlock);
  };

  /* hook for validation */
  const [errors, setErrors] = useState({});

  /* function to validate form */
  const validate = () => {
    const newErrors = {};

    if (title.trim() === "") {
      newErrors.title = t("Please enter a title for the plan.");
    }
    if (!pricing) {
      newErrors.pricing = t("Please set a price for the plan.");
    } else if (Number(pricing) <= 0) {
      newErrors.pricing = t("Price must be a positive number.");
    }
    if (!duration) {
      newErrors.duration = t("Please specify the plan's duration in days.");
    } else if (Number(duration) <= 0) {
      newErrors.duration = t("Duration must be a positive number of days.");
    }
    if (kpis.some((kpi) => kpi.value.trim() === "")) {
      newErrors.kpis = t(
        "Please fill out all feature fields or remove the empty ones."
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // function to get plan details
  const getPlanDetails = async () => {
    if (!planId) return;
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_PLAN_DETAILS}/${planId}`;
      const response = await getData(requestUrl);

      if (response.status) {
        const { data } = response;
        setTitle(data.title || "");
        setDescription(data.description || "");
        setPricing(data.price || "");
        setDuration(data.duration || "");
        setnoOfPersonsAllowed(data.persons || "");

        if (data.kpis && data.kpis.length > 0) {
          setKpis(data.kpis.map((kpi) => ({ value: kpi })));
        } else {
          setKpis([]); // Ensure it's an empty array if no KPIs
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // function to save plan
  const saveHandler = async () => {
    if (!validate()) {
      if (offcanvasBodyRef.current) {
        offcanvasBodyRef.current.scroll({ top: 0, behavior: "smooth" });
      }
      return;
    }

    setIsSaving(true);
    try {
      let sendingData = {
        title,
        description,
        duration,
        price: pricing,
        persons: noOfPersonsAllowed || 0,
        kpis: kpis.map((kpi) => kpi.value), // Send only the values
      };

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (planId) {
        requestUrl += `${url.API_UPDATE_PLAN}/${planId}`;
        response = await putData(requestUrl, sendingData);
      } else {
        requestUrl += `${url.API_ADD_PLAN}`;
        response = await postData(requestUrl, sendingData);
      }

      if (response.status) {
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#savePlan")
        ).hide();
        resetHandler();
        afterPopupCLose();
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSaving(false);
    }
  };

  // function to reset form
  const resetHandler = () => {
    setTitle("");
    setDescription("");
    setPricing("");
    setDuration("");
    setnoOfPersonsAllowed("");
    setKpis([]);
    setPlanId(null);
    setErrors({});
  };

  // useEffect to fetch plan details when planId changes
  useEffect(() => {
    if (planId) {
      getPlanDetails();
    } else {
      // Set default for new plan
      setKpis([kpistemplate]);
    }
  }, [planId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="savePlan"
      aria-labelledby="savePlanLabel"
    >
      {/* Header design similar to SaveFeedbackRulePopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              {" "}
              receipt_long{" "}
            </span>{" "}
            {/* Using 'receipt_long' icon as a placeholder */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {planId ? t("Edit Plan") : t("Create New Plan")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {planId
                ? t("Manage existing plan details")
                : t("Define a new plan")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      {/* Body */}
      <div ref={offcanvasBodyRef} className="offcanvas-body p-4">
        {isSaving && ( // Using isSaving as a general loading indicator for the popup
          <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 z-index-1050">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">
                {t("Loading plan details...")}
              </span>
            </div>
            <p className="text-primary mt-3 fw-bold">
              {t("Loading plan details...")}
            </p>
          </div>
        )}
        {/* Professional Card Layout */}
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* Title */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="planTitle"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="planTitle"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Professional Tier")}
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: "" }));
                    }
                  }}
                />
                {errors.title && (
                  <div className="invalid-feedback d-block">{errors.title}</div>
                )}
              </div>

              {/* Description */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="planDescription"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Description")}
                </label>
                <textarea
                  id="planDescription"
                  rows="3"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t(
                    "Provide a brief summary of what this plan includes."
                  )}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>

              {/* Price, Duration, Persons */}
              <div className="d-flex flex-column flex-md-row mb-4 gap-3">
                <div className="form-group p-3 border rounded-8 shadow-sm bg-white flex-fill">
                  <label
                    htmlFor="planPrice"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Price ($)")} <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="planPrice"
                    min="0"
                    className={`form-control fs-sm shadow-none ${
                      errors.pricing ? "is-invalid" : "border border-gray-300"
                    }`}
                    placeholder={t("e.g., 29.99")}
                    value={pricing}
                    onChange={(e) => {
                      setPricing(e.target.value);
                      if (errors.pricing) {
                        setErrors((prev) => ({ ...prev, pricing: "" }));
                      }
                    }}
                  />
                  {errors.pricing && (
                    <div className="invalid-feedback d-block">
                      {errors.pricing}
                    </div>
                  )}
                </div>
                <div className="form-group p-3 border rounded-8 shadow-sm bg-white flex-fill">
                  <label
                    htmlFor="planDuration"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Duration (days)")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="planDuration"
                    min="1"
                    className={`form-control fs-sm shadow-none ${
                      errors.duration ? "is-invalid" : "border border-gray-300"
                    }`}
                    placeholder={t("e.g., 30")}
                    value={duration}
                    onChange={(e) => {
                      setDuration(e.target.value);
                      if (errors.duration) {
                        setErrors((prev) => ({ ...prev, duration: "" }));
                      }
                    }}
                  />

                  {errors.duration ? (
                    <div className="invalid-feedback d-block">
                      {errors.duration}
                    </div>
                  ) : (
                    <div className="form-text">
                      {t("30=monthly, 90=quarterly, 365=yearly")}
                    </div>
                  )}
                </div>
                <div className="form-group p-3 border rounded-8 shadow-sm bg-white flex-fill">
                  <label
                    htmlFor="planPersons"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Users Allowed")}
                  </label>
                  <input
                    type="number"
                    id="planPersons"
                    min="0"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder={t("e.g., 5")}
                    value={noOfPersonsAllowed}
                    onChange={(e) => setnoOfPersonsAllowed(e.target.value)}
                  />
                  <div className="form-text">{t("Enter 0 for unlimited")}</div>
                </div>
              </div>

              {/* KPIs / Features Repeater */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                  {t("Features")}
                </label>
                {kpis.map((kpi, index) => (
                  <div className="input-group mb-3" key={index}>
                    <input
                      type="text"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t("e.g., 24/7 Email Support")}
                      value={kpi.value}
                      onChange={(e) => changeKpi(index, e.target.value)}
                    />
                    <button
                      className="btn btn-outline-primary d-flex align-items-center"
                      type="button"
                      onClick={() => onDeleteKpi(index)}
                    >
                      <span className="material-symbols-outlined fs-6">
                        delete
                      </span>
                    </button>
                  </div>
                ))}
                {errors.kpis && (
                  <div className="text-danger fs-sm mt-2">{errors.kpis}</div>
                )}
                <div className="mt-3">
                  <Link
                    to="#"
                    onClick={onAddKpi}
                    className="text-primary fw-medium d-inline-flex align-items-center gap-1 text-decoration-none"
                  >
                    <span className="material-symbols-outlined">
                      add_circle
                    </span>
                    <span>{t("Add Feature")}</span>
                  </Link>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Plan")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SavePlanPopup;
